import { render, staticRenderFns } from "./Boxs.vue?vue&type=template&id=907a2f58&scoped=true&"
import script from "./Boxs.vue?vue&type=script&lang=js&"
export * from "./Boxs.vue?vue&type=script&lang=js&"
import style0 from "./Boxs.vue?vue&type=style&index=0&id=907a2f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907a2f58",
  null
  
)

export default component.exports